/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInspectionDataCategoryDto } from '../../models/create-inspection-data-category-dto';
import { InspectionDataCategoryDto } from '../../models/inspection-data-category-dto';

export interface InspectionDataControllerCreateCategory$Params {
      body: CreateInspectionDataCategoryDto
}

export function inspectionDataControllerCreateCategory(http: HttpClient, rootUrl: string, params: InspectionDataControllerCreateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerCreateCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionDataCategoryDto>;
    })
  );
}

inspectionDataControllerCreateCategory.PATH = '/api/inspection-data/category';
